import { TrustPilotReviewsWidget as UITrustPilotReviewsWidget } from "@jti/ui/components/TrustPilotReviewsWidget/TrustPilotReviewsWidget";

import type { TrustPilotReviewsWidgetProps } from "./TrustPilotReviewsWidget.builder";

export function TrustPilotReviewsWidget(props: TrustPilotReviewsWidgetProps) {
  return (
    <UITrustPilotReviewsWidget
      disableForCurrentPage={props.disableForCurrentPage}
      styleHeight={props.styleHeight}
      styleWidth={props.styleWidth}
      stars={props.stars}
      reviewsPerPage={props.reviewsPerPage}
      sku={props.sku}
    />
  );
}
